const montarFiltroPessoa = (valor, tiposPessoaId) => {
  const texto = valor ?? "";
  const filtros = {
    codigo: texto,
    nomeRazaoSocial: texto,
    apelidoFantasia: texto,
  };
  const documento = texto.replace(/[^A-Za-z0-9]/g, "").toUpperCase();
  if (documento) {
    filtros.cnpjCpf = documento;
  }
  if (tiposPessoaId === 4) {
    filtros.vendedor = "true";
  }
  return filtros;
};

export default montarFiltroPessoa;
